import { computed } from 'vue';
import { useStoreGetters } from 'dashboard/composables/store';
import { ALL_PERMISSIONS } from 'dashboard/constants/permissions';

const DEFAULT_AGENT_PERMISSIONS = [
  'conversation.view',
  'conversation.manage',
  'conversation.message.send',
  'conversation.tab.unassigned',
  'conversation.tab.all',
  'conversation.filter',
  'contact.view',
  'contact.create',
  'contact.edit',
  'report.overview.view',
  'helpcenter.view',
  'team_chat.view',
];

export function usePermissions() {
  const getters = useStoreGetters();

  const permissions = computed(() => {
    const user = getters.getCurrentUser.value;
    const accountId = getters.getCurrentAccountId.value;
    const accountInfo = user?.accounts?.find(
      a => Number(a.id) === Number(accountId)
    );
    if (!accountInfo) return [];
    if (
      Array.isArray(accountInfo.permissions) &&
      accountInfo.permissions.length > 0
    ) {
      return accountInfo.permissions;
    }
    // Fallback for cached sessions before granular permissions were added
    return accountInfo.role === 'administrator'
      ? ALL_PERMISSIONS
      : DEFAULT_AGENT_PERMISSIONS;
  });

  const can = perm => permissions.value.includes(perm);
  const canAny = perms => perms.some(can);
  const canAll = perms => perms.every(can);

  return { permissions, can, canAny, canAll };
}
